import { CalendarClock, MapPin } from "lucide-react";
import { fmtDate } from "@/lib/format";
import { L } from "@/i18n";
import { Panel } from "./Panel";

export const ExamsCard = ({ exams }) => (
  <Panel
    testId="card-exams-summary"
    className="lg:col-span-4"
    title={L("Upcoming exams", "Próximos exames")}
    subtitle={L("{u} scheduled · {p} completed/expired", "{u} agendados · {p} realizados/expirados", { u: exams.upcoming.length, p: exams.pastCount })}
  >
    {exams.upcoming.length === 0 ? (
      <div className="flex flex-col items-center py-8 text-center" data-testid="exams-empty">
        <CalendarClock className="h-6 w-6 text-slate-600 mb-2" />
        <p className="text-sm text-slate-400">{L("No exams scheduled.", "Sem exames agendados.")}</p>
      </div>
    ) : (
      <ul className="space-y-3">
        {exams.upcoming.slice(0, 5).map((e) => (
          <li key={e.id} className="flex gap-3 rounded-md bg-[#0f172a] p-3" data-testid={`exam-item-${e.id}`}>
            <span className="h-fit rounded bg-amber-500/10 px-2 py-1 font-mono text-xs text-amber-400">{e.module}</span>
            <div className="min-w-0 text-xs">
              <p className="text-slate-200 truncate">{e.module_name}</p>
              <p className="mt-0.5 text-slate-500">
                {fmtDate(e.exam_date)} {e.exam_time} · {L("{n} students", "{n} alunos", { n: e.assigned_user_ids?.length ?? 0 })}
              </p>
              {e.location && (
                <p className="mt-0.5 flex items-center gap-1 text-slate-500"><MapPin className="h-3 w-3" />{e.location}</p>
              )}
            </div>
          </li>
        ))}
      </ul>
    )}
  </Panel>
);
